import type { Resource } from '../../';
export const general_nextSlide: Resource = {"default":"Next Slide"};
